package ru.it_mozaika.sender.common.models

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

@Serializable
data class S3File(
    val id: String,
    val filename: String,
    val filenameExtension: String,
    @Contextual val creationDate: LocalDateTime,
)
